import {Component, Input} from "@angular/core";
import {DICTIONARY} from "../../dictionary";
import {GeneralService} from "../../services/generalService";

@Component({
	selector: 'search-in-page',
	templateUrl: './search-in-page.component.html',
})
export class SearchInPageComponent {
	@Input() searchSelector;
	@Input() titleSelector;
	@Input() subtitleSelector;
	@Input() isHighlightSelection = true;

	constructor(public gs:GeneralService) {
	}

	searchTxt = '';
	dic = DICTIONARY;
	showSearchResults;
	searchResults: { element: HTMLElement; title: string; subtitle: string }[] = [];

	onSearchChange(): void {
		if (!this.searchTxt) {
			this.showSearchResults = false;
			this.searchResults = [];
			return;
		}

		const elements = Array.from(document.querySelectorAll(this.searchSelector)) as HTMLElement[];

		this.searchResults = elements
			.map((el) => {
				const title = (el.querySelector(this.titleSelector)?.textContent || '').trim();
				const subtitle = (el.querySelector(this.subtitleSelector)?.textContent || '').trim();
				const fullText = el.innerText || '';

				let score = 0;
				if (title.toLowerCase().includes(this.searchTxt)) score += 3;
				if (subtitle.toLowerCase().includes(this.searchTxt)) score += 2;
				if (fullText.toLowerCase().includes(this.searchTxt)) score += 1;

				return { element: el, title, subtitle, fullText, score };
			})
			.filter(({ fullText }) =>
				fullText.toLowerCase().includes(this.searchTxt.toLowerCase())
			)
			.sort((a, b) => b.score - a.score) ;

		this.showSearchResults = true;
	}

	selectResult(resultObj) {
		this.scrollToElement(resultObj.element);
		if (this.isHighlightSelection) {
			this.highlightSelectedElement(resultObj.element);
		}
	}

	scrollToElement(el: HTMLElement): void {
		el.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	highlightSelectedElement(element: HTMLElement): void {
		element.classList.add('found-in-page');

		setTimeout(() => {
			document.addEventListener('click', () => {
				element?.classList.remove('found-in-page');
			}, {once: true, capture: true,});
		}, 0);
	}
}
